'use client';
import { LucideIcon } from 'lucide-react';

interface TProps {
  heading?: string,
  subHeading?: string,
  features?: {
    id: number,
    name: string,
    desc: string,
    icon: LucideIcon,
  }[]
}

const FeatureSection = ({
  heading = "Why Organizers Love Greet",
  subHeading = "We’ve been in your shoes. We know the struggles. That’s why we created Greet - a platform built by organizers, for organizers.",
  features,
}: TProps) => {
  return (
    <section className='bg-white py-16 lg:py-24'>
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div className='mx-auto mb-16 max-w-3xl text-center'>
          <h2 className='text-3xl leading-11 font-extrabold text-gray-900 sm:text-4xl sm:leading-12 md:leading-16 lg:text-5xl'>
            {heading}
          </h2>
          <p className='mt-2 text-base font-semibold text-gray-500'>
            {subHeading}
          </p>
        </div>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3'>
          {features?.map((feature) => {
            const Icon = feature.icon;

            return (
              <div
                key={feature.id}
                className='relative flex cursor-pointer flex-col items-start overflow-hidden rounded-3xl border border-gray-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl'
              >
                <div
                  className={`bg-primary mb-6 flex h-14 w-14 items-center justify-center rounded-xl shadow-md`}
                >
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className='mb-3 text-lg font-bold text-gray-900'>
                  {feature.name}
                </h3>
                <p className='text-sm text-gray-600'>{feature.desc}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;